'use client';

import { PropsWithChildren } from 'react';
import Slider from 'react-slick';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SliderArrowProps {
  className?: string;
  onClick?: () => void;
  direction?: 'left' | 'right';
}

const SliderArrow = ({ className, onClick, direction = 'left' }: SliderArrowProps) => {
  return (
    <div
      className={`${className} absolute ${
        direction === 'left' ? 'left-2' : 'right-2'
      } top-0 bottom-0 flex items-center`}
    >
      <button
        type="button"
        onClick={onClick}
        className="bg-white/70 py-4 px-0.5 rounded cursor-pointer hover:bg-white/80 z-10"
      >
        {direction === 'left' && <FontAwesomeIcon icon={faChevronLeft} className="w-7 h-7 text-black/50" />}
        {direction === 'right' && <FontAwesomeIcon icon={faChevronRight} className="w-7 h-7 text-black/50" />}
      </button>
    </div>
  );
};

export const BlogPostCustomSlider = ({ children }: PropsWithChildren) => (
  <Slider
    {...{
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 750,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: false,
      fade: true,
      nextArrow: <SliderArrow direction="right" />,
      prevArrow: <SliderArrow />,
    }}
  >
    {children}
  </Slider>
);
